import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px  0px',
      marginLeft: '18px',
      '& .MuiSlider-root': {
        width: '92%',
        color: palette.green,
      },
    },
    ...overrideClasses,
  });

export const overrideExplanationHover = {
  icon: {
    marginRight: 0,
    marginTop: 0,
    marginLeft: 5,
    fontSize: 16,
  },
  explanationHover: { alignItems: 'center', display: 'flex' },
};
